module.exports = require('./Loader');

module.exports.Resource = require('./Resource');

module.exports.middleware = {
    caching: {
        memory: require('./middlewares/caching/memory')
    },
    parsing: {
        blob: require('./middlewares/parsing/blob')
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/pixi.js/~/resource-loader/src/index.js
 ** module id = 112
 ** module chunks = 0
 **/